import { useEffect, useState } from 'react';

interface UseSyncAnimationsProps {
  firstTimeout: number;
  secondTimeout: number;
}

interface UseSyncAnimationsReturn {
  isFirstAnimated: boolean;
  isSecondAnimated: boolean;
}

let enableTimeout: NodeJS.Timeout | undefined;
let disableTimeout: NodeJS.Timeout | undefined;

export const useSyncAnimations = (props: UseSyncAnimationsProps): UseSyncAnimationsReturn => {
  const { firstTimeout, secondTimeout } = props;
  const [isFirstAnimated, setIsFirstAnimated] = useState<boolean>(false);
  const [isSecondAnimated, setIsSecondAnimated] = useState<boolean>(false);

  useEffect(() => {
    if (isFirstAnimated) {
      enableTimeout = setTimeout(() => {
        setIsSecondAnimated(true);
        disableTimeout = setTimeout(() => {
          setIsFirstAnimated(false);
        }, 200);
      }, firstTimeout - 200);
    }
  }, [isFirstAnimated, firstTimeout]);

  useEffect(() => {
    if (isSecondAnimated) {
      enableTimeout = setTimeout(() => {
        setIsFirstAnimated(true);
        disableTimeout = setTimeout(() => {
          setIsSecondAnimated(false);
        }, 200);
      }, secondTimeout - 200);
    }
  }, [isSecondAnimated, secondTimeout]);

  useEffect(() => {
    setIsFirstAnimated(true);

    return () => {
      if (enableTimeout) {
        clearTimeout(enableTimeout);
      }
      if (disableTimeout) {
        clearTimeout(disableTimeout);
      }
    };
  }, []);

  return {
    isFirstAnimated,
    isSecondAnimated,
  };
};
